import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { PhoenixBreakpointChangeEvent } from '../../lib/types';
import { getCurrentBreakpoint } from '../../lib/util';

@customElement('phoenix-details-summary')
export default class PhoenixDetailsSummary extends LitElement {
    page = this.closest('phoenix-page');
    details = this.querySelector('details');

    constructor() {
        super();
        this._toggleStates(getCurrentBreakpoint());
        this.page?.addEventListener(
            'phoenix:breakpoint:changed',
            this.handleBreakpointChange.bind(this) as EventListener
        );
    }

    _toggleStates(breakpoint: string) {
        this.classList.toggle('is-open', breakpoint !== 'A');
        this.details?.toggleAttribute('open', breakpoint !== 'A');
    }

    handleBreakpointChange(event: PhoenixBreakpointChangeEvent) {
        const { detail } = event;
        this._toggleStates(detail.value);
    }

    protected createRenderRoot(): Element | ShadowRoot {
        return this;
    }
}
